export default __webpack_public_path__ + "static/media/bhajiImage.e23a15bb.svg";